var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-dot-status"},[_c('span',{staticClass:"ws-dot-status__indicator",class:[`ws-dot-status__indicator_type_${_vm.type}`]})])
}
var staticRenderFns = []

export { render, staticRenderFns }